import { Card } from '@domain/cards/cards.types';
import { flatten } from '@shared/utils/array';
import { createSelector } from 'reselect';

export const getCardById = (state, cardId) => {
    const allCards = getCards(state);

    const card = allCards.find((item : Card) => (item.id === cardId));

    return card;
};

export const getExcludedCards = state => state.workflow.excludedCards;
export const getLastSync = state => state.workflow.lastSync;
export const getCards = createSelector(
    (state: {workflow:{columns}}) => state.workflow.columns,
    columns => flatten(Object.values(columns)),
);
